@if (value) {
  {{ value }}
} @else if (params.cellRendererParams['defaultTo']) {
  {{ params.cellRendererParams['defaultTo'] | translate }}
} @else {
  <span class="text-slate-300">
    -
  </span>
}

